import { Component, ViewChild, Input, TemplateRef, ElementRef, ChangeDetectorRef, OnInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AppService } from '../app.service';
import { qmsService } from '../qms/qms.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { PaginationService } from 'src/app/PaginationService';
import { MatPaginatorModule } from '@angular/material/paginator';
import { messageService } from '../message.service';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { EditorComponent } from '../editor/editor.component';
export interface PopupData {
  title: string;
}
@Component({
  selector: 'app-forms-and-logs-more-reports',
  templateUrl: './forms-and-logs-more-reports.component.html',
  styleUrls: ['./forms-and-logs-more-reports.component.scss']
})
export class FormsAndLogsMoreReportsComponent implements OnInit, OnChanges {
  isProcessing: boolean = false;
  showCharts: boolean = false;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  templateStatusList: any = [];
  formsTemplateNameList: any = [];
  formsSectionDataList: any = [];
  formsSectionDataStatusList: any = [];
  chartOptionsForTemplateStatus: any;
  chartOptionsForFormsTemplateName: any;
  chartOptionsForFormsSectionDataStatus: any;
  chartOptionsForFormsSectionData: any;
  titleName = '';
  clickedType = "";
  clickedVal = "";
  clickedStageStatusVal = "";
  templateDropDown: any = [];
  whereValsForExcel: any;
  selectedTemplateType: any = null;
  selectedFromType: any = null;
  selectedsectionType: any = null;
  selectedFormTemplateType: any = null;
  templateTypeSearchText: string = '';
  fromTypeSearchText: string = '';
  SectionTypeSearchText: string = '';
  dropDownFortemplateTypeList: any = [];
  dropDownForfromTypeList: any = [];
  dropDownForsectionfromTypeList: any = [];
  sectionTemplateFromDropDown: any = [];
  dropDownForsectionTemplatefromTypeList: any = [];
  fromDropDown: any = [];
  sectionFromDropDown: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  columnLists: any = {};
  formTemplateUsersList: any = [];
  formTemplateUsersListTemp: any = [];
  formTemplateUserData: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  templateId: any;
  formId: any;
  currentUrl: string;
  pdfSearchText: string = '';
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};
  pagedItems: any[];
  error = '';
  @Input() data: any;
  data1: any;
  data2: any;
  reportObj: any = {};
  module: any;
  _temp: any = {};
  tableReportFormSectionDataStatusList: any = [];
  showingRowsText = "Showing rows";
  pagedItems2: any = [];
  showReportFlagValue: boolean = false;
  constructor(public changeDetector: ChangeDetectorRef, public dialog: MatDialog, public appService: AppService, public route: ActivatedRoute, public router: Router, public snackBar: MatSnackBar,
    public elem: ElementRef, public paginationService: PaginationService, public message: messageService, public qmsservice: qmsService, public datePipe: DatePipe, public activatedRoute: ActivatedRoute, public atPaginatorModule: MatPaginatorModule) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }
  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('reportPopupForZoom', { static: true }) reportPopupForZoom: TemplateRef<any>;
  visibleReportPopupForZoom: MatDialogRef<TemplateRef<any>>;
  @ViewChild('templateType') newTemplateType: MatSelect;
  newTemplateTypeSelection = false;
  @ViewChild('FromtemplateType') newFromTemplateType: MatSelect;
  newFormTemplateTypeSelection = false;
  @ViewChild('fromType') newFromType: MatSelect;
  newFromTypeSelection = false;
  reportPopupConfig = {
    width: '90%',
    height: '600px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  colorList: string[] = [
    '#F9F871',
    '#6B7887',
    '#00A6A9',
    '#BF83FF',
    '#005C8A',
    '#05004E',
    '#834160',
    '#9EADBD',
    '#BA7393',
    '#DEEBFE',
    '#96E480',
    '#839EFF',
    '#00A6A9',
    '#0081A5',
    '#291F1E',
    '#401F3E',
    '#C0DFA1',
    '#14342B',
    '#D0DB97',
    '#B07BAC',
    '#CF1259',
    '#E6B89C'
  ];
  colorMethod(val: any, iVal: any) {
    if (val == "Closed" || val == "Completed" || val == "Passed") {
      return "#96E480";
    } else if (val == "Critical" || val == "High") {
      return "#EB5757";
    } else if (val == "Major" || val == "Medium") {
      return "#FF947A";
    } else if (val == "In Progress" || val == "Minor") {
      return "#005C8A";
    } else {
      return this.colorList[iVal];;
    }
  }
  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.formTemplateUsersList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.formTemplateUsersList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }
  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.formTemplateUsersList[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
  }
  searchValue: any;
  searchValue2: any;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  users: any[];

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.formTemplateUsersList.length, page, this.perPage, targetpage);
    if (this.formTemplateUsersList.length > 0) {
      this.pagedItems = this.formTemplateUsersList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  genReport() {
    this.isProcessing = true;

    let data1 = {
    }
    const promises = [
      firstValueFrom(this.appService.getTemplateStatus(data1)),
      firstValueFrom(this.appService.getFormsStatus(data1)),
      firstValueFrom(this.appService.getFormsSectionDataStatus(data1)),
      firstValueFrom(this.appService.getFormsSectionData(data1)),
    ]; // Convert each observable to a promise
    // Use Promise.all to wait for all promises to resolve
    Promise.all(promises)
      .then(([templateStatusList, formsTemplateNameList, formsSectionDataStatusList, formsSectionDataList]) => {
        this.templateStatusList = templateStatusList;
        this.formsTemplateNameList = formsTemplateNameList;
        this.formsSectionDataStatusList = formsSectionDataStatusList;
        this.formsSectionDataList = formsSectionDataList;
        this.isProcessing = false;
      },
        error => {
          console.error('Error in forkJoinObservable:', error);
          this.isProcessing = false;
        });
  }

  refreshbreadcrumb: boolean = true;
  ngOnChanges() {
    this.refreshbreadcrumb = false;
    console.log(this.refreshbreadcrumb);
    this.message.breadcrumbData.thirdLevel = this.qmsservice.formsAndLogsReportFor; // Force change detection
    this.changeDetector.detectChanges();
    this.refreshbreadcrumb = true;
    console.log(this.refreshbreadcrumb);
  }

  moreFormsAndLogsReportDetails(value: any) {
    if (value == 'Default') {
      this.qmsservice.formsAndLogsReportFor = value;
      this.message.breadcrumbData.thirdLevel = "";
      this.router.navigate(['/dashboard/FormsAndLogsReports']);
    } else {
      this.qmsservice.formsAndLogsReportFor = value;
      this.message.breadcrumbData.thirdLevel = value;
      this.ngOnChanges();
      this.resetFunction();
      this.refreshbreadcrumb = true;
      this.router.navigate(['/dashboard/FormsAndLogsMoreReports']);
      console.log("data activity=====", this.qmsservice.formsAndLogsReportFor);
    }
  }
  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'pdf-select-all');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;
    if (field) {
      field.style.color = shouldBeRed ? 'red' : '#005c8a';
    }
  }
  fieldValidation(elementIds: string) {
    const element = document.getElementById(elementIds) as HTMLInputElement;
    element.style.color = 'red';
  }
  onTemplateSelectionChange(event: any, item: any) {
    console.log(event.isUserInput);
    console.log(item)
    if (event.isUserInput) {
      this.handleDropDownValidation('templateAlert', item)
      this.selectedFormTemplateType = item.valueExp;
      this.selectedFromType = null;
      this.selectedsectionType = null;
      const data = {
        templateId: this.selectedFormTemplateType ? this.selectedFormTemplateType : null,

      };
      this.appService.getFormssectionDropdown(data).subscribe({
        next: (response: any) => {
          this.dropDownForsectionfromTypeList = response;
          // Populate the "Select Forms" dropdown
          this.showReportFlagValue = false;
          this.pagedItems = [];
          this.pagedItems2 = [];
          this.sectionFromDropDown = [];
          for (const form of this.dropDownForsectionfromTypeList) {
            this.sectionFromDropDown.push({
              valueExp: form.formId,
              displayExp: form.formName
            });
          }
        }, error: (error: any) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }
  onTemplateFromSelectionChange(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedFromType = item.valueExp;
      const data = {
        templateId: this.selectedFormTemplateType ? this.selectedFormTemplateType : null, // Pass the selected template ID(s) or value(s)
        formId: this.selectedFromType ? this.selectedFromType : null
      };

      // Call the API to fetch forms based on selected template(s)
      this.appService.getTemplateFormssectionDropdown(data).subscribe({
        next: (response: any) => {
          this.dropDownForsectionTemplatefromTypeList = response;
          // Populate the "Select Forms" dropdown
          this.sectionTemplateFromDropDown = [];
          for (const form of this.dropDownForsectionTemplatefromTypeList) {
            this.sectionTemplateFromDropDown.push({
              valueExp: form.formId,
              displayExp: form.formName
            });
          }
        }, error: (error: any) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.selectedFromType = null;
    }
  }
  onTemplateFromSectionSelectionChange(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedsectionType = item.valueExp;
    } else {
      this.selectedsectionType = null;
    }
  }
  onTemplateSelectnew(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedTemplateType = item.valueExp;
    }
  }
  onFromSelectnew(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedFromType = item.valueExp;
    }
  }
  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }
  resetFunction() {
    this.selectedFromType = null;
    this.selectedTemplateType = null;
    this.selectedFromType = null;
    this.selectedsectionType = null;
    this.selectedFormTemplateType = null;
    this.showReportFlagValue = false;
    this.pagedItems = [];
    this.pagedItems2 = [];
  }
  getcallMethod() {
    this.showReportFlagValue = true;
    if (this.qmsservice.formsAndLogsReportFor === 'Template Vs Users') {
      this.isProcessing = true;
      this.formTemplateUsersList = [];
      const data = {

        gridName: 'FORM_TEMPLATE_USERS',

      }
      this.appService.getDynamicGridHeaders(data).subscribe({
        next: (response: any) => {

          response.orderByClause ??= "";
          this.makeStickyColumns = response.fixedFieldCnt;
          let data1: any = {

            gridName: 'FORM_TEMPLATE_USERS',
            tableOrViewName: 'ONEQMS_FORM_TEMPLATE_USERS_VW',
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            templateIdFromQmsReportTemplate: this.templateId,
            manualEntryDataFields: response.manualEntryDataFields,
            clobColumnlist: response.closblist || "",
            blobColumnlist: response.bloblist || "",
            templateId: this.selectedTemplateType ? this.selectedTemplateType : null,
            reModule: "fAndLMore",
            formId: 0
          }
          this.reportObj = { ...data1, ...data };
          this.appService.getDynamicGridData(data1).subscribe({
            next: (response1: any) => {
              this.formTemplateUsersList = response1;
              console.log('Data - ', this.formTemplateUsersList);
              data1.columnsListarray = data1.columnsList.split(",");
              data1.fieldColumnarray = data1.fieldLabelsList.split(",");
              data1.invisibleColumnarray = data1.invisibleColumn.split(",");
              data1.fieldSizeListArray = data1.fieldSizeList.split(",");
              let rendereddata: any;
              this.columnLists.columnsListarray = data1.columnsListarray;
              this.columnLists.fieldLabelsList = data1.fieldLabelsList;
              this.columnLists.fieldColumnarray = [];
              for (let p = 0; p < data1.fieldColumnarray.length; p++) {
                this.columnLists.fieldColumnarray.push({
                  "fieldColumnarray": data1.fieldColumnarray[p],
                  "width": data1.fieldSizeListArray[p] + 'px'
                })
              }
              this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
              this.columnLists.fieldSizeListArray = [];
              for (const fieldSize of data1.fieldSizeListArray) {
                this.columnLists.fieldSizeListArray.push(fieldSize + 'px');
              }
              for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
                const column = this.columnLists.columnsListarray[y];
                if (this.columnLists.invisibleColumnarray.includes(column)) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
              let tableData = {
                tablename: data1.tableOrViewName
              };
              this.columnLists.columnsListarray1 = [];
              this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const dataType of this.dataTypeList) {
                    if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                      break; // Exit the loop once a match is found, assuming only one match is needed
                    }
                  }
                }
                for (const user of this.formTemplateUsersList) {
                  for (const dataType of this.dataTypeList) {
                    if (dataType.fieldType === 'CHECKBOX') {
                      user[dataType.columnName] = user[dataType.columnName] === "Y";
                    }
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.setPage(1, 0);
                this.pager.totalPages = undefined;
              });
              this.message.gridList = this.formTemplateUsersList;
              this.collectionSize = this.formTemplateUsersList.length;
              this.totalPages = Math.ceil(this.formTemplateUsersList.length / this.itemsPerPage);
            }, error: (error: any) => {
              this.isProcessing = false;
              throw error;
            }
          });
          this.isProcessing = false;
        }, error: (error: any) => {
          this.isProcessing = false;
          throw error;
        }
      });

    } else if (this.qmsservice.formsAndLogsReportFor === 'Forms Vs Users') {
      this.isProcessing = true;
      this.formTemplateUsersList = [];
      const data = {

        gridName: 'FORM_USERS'
      }
      this.appService.getDynamicGridHeaders(data).subscribe({
        next: (response: any) => {

          response.orderByClause ??= "";
          this.makeStickyColumns = response.fixedFieldCnt;
          let data1: any = {

            gridName: 'FORM_USERS',
            tableOrViewName: 'ONEQMS_FORM_USERS_VW',
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            templateIdFromQmsReportTemplate: this.templateId,
            manualEntryDataFields: response.manualEntryDataFields,
            clobColumnlist: response.closblist || "",
            blobColumnlist: response.bloblist || "",
            reModule: "fAndLMore",
            formId: this.selectedFromType ? this.selectedFromType : null,
          }
          this.reportObj = { ...data1, ...data };
          this.appService.getDynamicGridData(data1).subscribe({
            next: (response1: any) => {
              this.formTemplateUsersList = response1;
              console.log('Data - ', this.formTemplateUsersList);
              data1.columnsListarray = data1.columnsList.split(",");
              data1.fieldColumnarray = data1.fieldLabelsList.split(",");
              data1.invisibleColumnarray = data1.invisibleColumn.split(",");
              data1.fieldSizeListArray = data1.fieldSizeList.split(",");
              let rendereddata: any;
              this.columnLists.columnsListarray = data1.columnsListarray;
              this.columnLists.fieldLabelsList = data1.fieldLabelsList;
              this.columnLists.fieldColumnarray = [];
              for (let p = 0; p < data1.fieldColumnarray.length; p++) {
                this.columnLists.fieldColumnarray.push({
                  "fieldColumnarray": data1.fieldColumnarray[p],
                  "width": data1.fieldSizeListArray[p] + 'px'
                })
              }
              this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
              this.columnLists.fieldSizeListArray = [];
              for (const fieldSize of data1.fieldSizeListArray) {
                this.columnLists.fieldSizeListArray.push(fieldSize + 'px');
              }
              for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
                const column = this.columnLists.columnsListarray[y];
                if (this.columnLists.invisibleColumnarray.includes(column)) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
              let tableData = {
                tablename: data1.tableOrViewName
              };
              this.columnLists.columnsListarray1 = [];
              this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const dataType of this.dataTypeList) {
                    if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                      break; // Exit the loop once a match is found, assuming only one match is needed
                    }
                  }
                }
                for (const user of this.formTemplateUsersList) {
                  for (const dataType of this.dataTypeList) {
                    if (dataType.fieldType === 'CHECKBOX') {
                      user[dataType.columnName] = user[dataType.columnName] === "Y";
                    }
                  }
                }

                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.setPage(1, 0);
                this.pager.totalPages = undefined;
              });
              this.message.gridList = this.formTemplateUsersList;
              this.collectionSize = this.formTemplateUsersList.length;
              this.totalPages = Math.ceil(this.formTemplateUsersList.length / this.itemsPerPage);
            }, error: (error: any) => {
              this.isProcessing = false;
              throw error;
            }
          });
          this.isProcessing = false;
        }, error: (error: any) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else if (this.qmsservice.formsAndLogsReportFor === 'Form Section Data') {
      if (this.selectedFormTemplateType) {
        this.isProcessing = true;
        this.whereValsForExcel = "";
        if (this.selectedFormTemplateType) {
          this.whereValsForExcel = " WHERE TEMPLATE_ID=" + this.selectedFormTemplateType;
        }

        if (this.selectedFromType) {
          this.whereValsForExcel = this.whereValsForExcel + " AND FORM_ID=" + this.selectedFromType;
        }

        if (this.selectedsectionType) {
          this.whereValsForExcel = this.whereValsForExcel + " AND SECTION_ID=" + this.selectedsectionType;
        }
        let data = {

          wherVal: this.whereValsForExcel
        }
        forkJoin([
          this.appService.getTableFormsSectionDataStatusForMore(data)]).subscribe(([formsSectionDataStatusTableValues]) => {
            this.tableReportFormSectionDataStatusList = formsSectionDataStatusTableValues;
            this.calculateTotalPages = this.collectionSize / this.perPage;
            this.pager.totalPages = undefined;
            this.collectionSize = this.tableReportFormSectionDataStatusList.length;
            this.totalPages = Math.ceil(this.tableReportFormSectionDataStatusList.length / this.itemsPerPage);
            this.setPage2(1, 0);
            this.isProcessing = false;
          });
        this.columnList = "Section Name,Form Name,Status,Is Verified,Verification Requested On,Verified By User,Verified On,Verifier Comments,Locked By User,Created On,Created By User,Updated On,Updated By User";
      } else {
        console.log("this.selectedTemplateType+++++++++++=", this.selectedTemplateType)
        this.fieldValidation("templateAlert");
      }
    }
  }

  applyFilter2(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tableReportFormSectionDataStatusList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tableReportFormSectionDataStatusList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat);
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  setPage2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportFormSectionDataStatusList.length, page, this.perPage, targetpage);
    this.pagedItems2 = this.tableReportFormSectionDataStatusList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    console.log("this.pagedItems2=", this.pagedItems2);
  }
  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }
  //Excell & PDF
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = [];
  }
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  popupDataTitle: PopupData = {
    title: ''
  };
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else {
      this.appService.isProcessingRep = true;
      this.data = {};
      this.data1 = {};
      this.data2 = {};
      let tname = "";
      let colList = "";
      let fieldList = "";
      if (this.qmsservice.formsAndLogsReportFor == 'Template Vs Users') {
        if (this.selectedTemplateType) {
          this.whereValsForExcel = " WHERE TEMPLATE_ID=" + this.selectedTemplateType + " AND ORG_ID=" + this.message.getOrgId() + " AND FORM_ID=0";

        } else {
          this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId() + " AND FORM_ID=0";

        } console.log("===", this.whereValsForExcel);
        this.data = {

          gridName: 'FORM_TEMPLATE_USERS',
          groupId: null
        }
        this.appService.getDynamicGridHeaders(this.data).subscribe((response: any) => {

          response.orderByClause ??= "";
          this.data1 = {

            gridName: 'FORM_TEMPLATE_USERS',
            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            templateId: this.selectedTemplateType ? this.selectedTemplateType : null,
            manualEntryDataFields: response.manualEntryDataFields,
            wherVal: this.whereValsForExcel,
            reModule: "fAndL"
          }

          this.data2 = {

            groupId: null,
            "logoId": this.selectedReportLogoValue ?? null,
            footer: this.selectedReportFooter,
            "isSaveRep": this.isSaveReport ? 'Y' : 'N',
            "reportName": this.qmsservice.formsAndLogsReportFor,
            "currentStatus": "NA",
            "groupName": this.qmsservice.formsAndLogsReportFor,
            module: null
          }
          this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
          debugger;
          if (value == 'Excel') {
            const pdfData = {
              ...this.reportObj, title: "Template Vs Users", columns: [],
              "informationTab": {
                "Report Name": "Template Vs Users",
                "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
              }
            }
            this.appService.downloadexcelForChart(pdfData, "Template Vs Users.xlsx");
          } else {
            console.log(this.columnLists.fieldColumnarray, "=================",);
            const pdfData = {
              ...this.reportObj, title: "Template Vs Users", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray).slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
            }
            this.appService.downloadPdfForChart(pdfData, "Template Vs Users.pdf");

          }
        });
      } else if (this.qmsservice.formsAndLogsReportFor == 'Forms Vs Users') {
        if (this.selectedFromType) {
          this.whereValsForExcel = " WHERE FORM_ID=" + this.selectedFromType + " AND ORG_ID=" + this.message.getOrgId();

        } else {
          this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId();

        }
        console.log("===", this.whereValsForExcel);
        this.data = {

          gridName: 'FORM_USERS',
          groupId: null
        }
        this.appService.getDynamicGridHeaders(this.data).subscribe((response: any) => {

          response.orderByClause ??= "";
          this.data1 = {

            gridName: 'FORM_USERS',
            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            templateId: this.selectedTemplateType ? this.selectedTemplateType : null,
            manualEntryDataFields: response.manualEntryDataFields,
            wherVal: this.whereValsForExcel,
            reModule: "fAndL"
          }
          this.data2 = {

            "logoId": this.selectedReportLogoValue ?? null,
            footer: this.selectedReportFooter,
            "isSaveRep": this.isSaveReport ? 'Y' : 'N',
            "reportName": this.qmsservice.formsAndLogsReportFor,
            "currentStatus": "NA",
            "groupName": this.qmsservice.formsAndLogsReportFor,
            groupId: null,
            module: null
          }
          this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
          debugger;
          if (value == 'Excel') {
            const pdfData = {
              ...this.reportObj, title: "Forms Vs Users", columns: [],
              "informationTab": {
                "Report Name": "Forms Vs Users",
                "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
              }
            }
            this.appService.downloadexcelForChart(pdfData, "Forms Vs Users.xlsx");
          } else {
            console.log(this.columnLists.fieldColumnarray, "=================",);
            const pdfData = {
              ...this.reportObj, title: "Forms Vs Users", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray).slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
            }
            this.appService.downloadPdfForChart(pdfData, "Forms Vs Users.pdf");
          }
        });
      } else if (this.qmsservice.formsAndLogsReportFor == 'Form Section Data') {
        this.appService.isProcessingRep = true;
        this.data = {};
        this.data1 = {};
        this.data2 = {};
        let tittle = "";
        let tname = "";
        let colList = "";
        let fieldList = "";
        tname = "ONEQMS_FORM_SECTION_DATA_VW";
        colList = "SECTION_NAME,FORM_NAME,STATUS,IS_VERIFIED,VERIFICATION_REQUESTED_ON,VERIFIED_BY_USER,VERIFIER_COMMENTS,VERIFIED_ON,LOCKED_BY_USER,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER";
        fieldList = this.columnList;
        tittle = "Form Section Data";
        this.data = {

          footer: this.selectedReportFooter,
          "logoId": this.selectedReportLogoValue ?? 0,
          "isSaveRep": this.isSaveReport ? 'Y' : 'N',
          "reportName": this.qmsservice.formsAndLogsReportFor,
          "currentStatus": "NA",
          "groupName": this.qmsservice.formsAndLogsReportFor,
          groupId: null
        }
        this.data1 = {

          tableOrViewName: tname,
          columnsList: colList,
          fieldLabelsList: fieldList,
          invisibleColumn: "",
          orderByClause: "",
          fieldSizeList: "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: "",
          codelistGroup: null,
          manualEntryDataFields: "",
          groupId: null,
          chartStatus: null,
          reModule: "fAndL"
        }
        this.data2 = {

          groupId: null,
          module: "DOCS",
          dateRangeAt: null,
          fromDate: null,
          toDate: null,
          intervals: null,
          taskType: null,
          wherVal: this.whereValsForExcel
        }

        this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
        debugger;
        if (value == 'Excel') {
          const pdfData = {
            ...this.reportObj, title: tittle, columns: [],
            "informationTab": {
              "Report Name": tittle,
              "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
            }
          }
          this.appService.downloadexcelForChart(pdfData, tittle + ".xlsx");
        } else {
          const pdfData = {
            ...this.reportObj, title: tittle, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
          }
          this.appService.downloadPdfForChart(pdfData, tittle + ".pdf");

        }

      }
    }
  }
  openReportPopup(item: any) {
    if (this.qmsservice.formsAndLogsReportFor == 'Template Vs Users' || this.qmsservice.formsAndLogsReportFor == 'Forms Vs Users') {
      console.log("this.columnLists=", this.columnLists);
      this.excelPdf.dropDown = this.columnLists.fieldColumnarray.map((column: any) => ({ valueExp: column.fieldColumnarray, displayExp: column.fieldColumnarray }));
      console.log("this.excelPdf.dropDown=", this.columnLists);
    } else {
      this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    }
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfSelection = false;
    this.reportName = this.qmsservice.formsAndLogsReportFor + new Date();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }

  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }


  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {

    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error: (error) => {
        console.log(error);

      }
    })
    this.isProcessing = false;

  }

  htmlContent: any;

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;
          console.log("data", this.reportFooterDropdown1);

          this.selectBoxForFooter();

          // Set the first object as default
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes("FORMS")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }
  //end excell & pdf
  ngOnInit() {
    this.route.params.subscribe(params => {
      this.refreshbreadcrumb = false;
      this.ngOnChanges();

      let data = {

      }
      this.appService.getFormsTemplateDropdown(data).subscribe((data: any) => {
        this.dropDownFortemplateTypeList = data;
        for (const template of this.dropDownFortemplateTypeList) {
          this.templateDropDown = this.templateDropDown.concat({
            valueExp: template.templateId,
            displayExp: template.templateName
          });
        }
      })
      this.appService.getFormsDropdown(data).subscribe((data: any) => {
        this.dropDownForfromTypeList = data;
        for (const form of this.dropDownForfromTypeList) {
          this.fromDropDown = this.fromDropDown.concat({
            valueExp: form.formId,
            displayExp: form.formName
          });
        }

      })
    });

    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("FRM", 0).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
    this.ngOnChangesReportFooter();
  }

  gridName: any;
  tableOrViewName: any;
  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    if (this.qmsservice.formsAndLogsReportFor === 'Forms Vs Users') {
      this.gridReorderComponent.reordercall('FORM_USERS', 'ONEQMS_FORM_USERS_VW', null, 0);
    } else if (this.qmsservice.formsAndLogsReportFor === 'Template Vs Users') {
      this.gridReorderComponent.reordercall('FORM_TEMPLATE_USERS', 'ONEQMS_FORM_TEMPLATE_USERS_VW', null, 0);
    }
  }
  onChildValueEmitted() {
    this.showReportFlagValue = false;
    this.getcallMethod();
    console.log("this.getcallMethod()", this.getcallMethod())
  };

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  isSaveReport: boolean = false;
  reportName: any;
  pdfDetailSearchText: string = '';
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }

  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log("this.dropDownDataForReportLogo=", this.dropDownDataForReportLogo);
      console.log("this.dropDownDataForReportLogo.reportImageList", this.dropDownDataForReportLogo.reportImageList);
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            console.log("this.imageIdList=", this.imageIdList);
            console.log("this.organizationReportImageDetails=", this.organizationReportImageDetails.length);
            for (const organizationReportImageDetail of this.organizationReportImageDetails) {

              console.log(
                "this.organizationReportImageDetails=",
                organizationReportImageDetail.reportImageId,
                this.imageIdList[i]
              );

              if (organizationReportImageDetail.reportImageId == this.imageIdList[i]) {

                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: organizationReportImageDetail.reportImageId,
                  displayExp: organizationReportImageDetail.reportImageName
                });

              }

            }
          }
        }
      } else {
        for (const organizationReportImageDetail of this.organizationReportImageDetails) {

          if (organizationReportImageDetail.reportImageId == this.dropDownDataForReportLogo.reportImageList) {

            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: organizationReportImageDetail.reportImageId,
              displayExp: organizationReportImageDetail.reportImageName
            });

          }

        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const reportLogoDropdownVal of this.reportLogoDropdown) {
          if (reportLogoDropdownVal.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = reportLogoDropdownVal.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }
}
